var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.492 2.49556C22.3601 2.0132 22.1028 1.57346 21.7457 1.22011C21.3885 0.866766 20.9441 0.612143 20.4565 0.4816C18.6717 0 11.4883 0 11.4883 0C11.4883 0 4.30461 0.0145777 2.51978 0.496178C2.03224 0.626729 1.58777 0.881365 1.23065 1.23473C0.873518 1.58809 0.616185 2.02786 0.484275 2.51022C-0.055596 5.64782 -0.265022 10.4288 0.499099 13.4409C0.631023 13.9232 0.888362 14.363 1.24549 14.7163C1.60262 15.0697 2.04707 15.3243 2.5346 15.4548C4.31944 15.9364 11.503 15.9364 11.503 15.9364C11.503 15.9364 18.6864 15.9364 20.4712 15.4548C20.9587 15.3243 21.4032 15.0697 21.7603 14.7163C22.1175 14.363 22.3748 13.9233 22.5068 13.4409C23.0762 10.2988 23.2517 5.5208 22.492 2.49556Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20215 11.3831L15.1613 7.96816L9.20215 4.55322V11.3831Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.c4b3254a21b5f3d34651686a93bb5a32.svg";
export { ForwardRef as ReactComponent };